import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["pullRight", "className", "children"];
import React from 'react';
import classNames from 'classnames';
var MenuItems = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var pullRight = _ref.pullRight,
    className = _ref.className,
    children = _ref.children,
    remainingProps = _objectWithoutProperties(_ref, _excluded);
  var dropdownMenuClasses = classNames('dropdown-menu', pullRight && 'pull-right', className);
  return /*#__PURE__*/React.createElement("ul", _extends({}, remainingProps, {
    className: dropdownMenuClasses,
    ref: ref,
    role: 'menu'
  }), children);
});
export default MenuItems;